export default {
  chartType: "columnchart",
  showTitle: true,
  showControls: true,
  showQuery: true,
  showColor: true,
  showSortZ: true,
  showSortX: true,
  showSortY: false,
  showNormalize: false,
  showRecency: true,
  showSize: true,
  showMetric: true,
  showMetricX: false,
  showMetricY: false,
  showTypeCats: false
};
